function* onload() {}

export { onload };
